var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center mx-0"}},[_c('a',{staticClass:"text-truncate",staticStyle:{"max-width":"90%"},attrs:{"href":_vm.actualLink,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.link))])])
}
var staticRenderFns = []

export { render, staticRenderFns }